import React, { FC } from 'react';
import { ReactComponent as Copy } from '../../../assets/Common/Copy.svg';

export const CopyIcon: FC = () => <Copy />;
